<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select
      v-if="professores"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="professores"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import ProfessorService from "../../../../domain/corpore/ProfessorService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-todos-professores",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    cursoId: null
  },
  mounted() {
    this.$el.value = this.value;
  },
  asyncComputed: {
    professores() {
      const professorService = new ProfessorService(this.$http);
      return professorService
        .getProfessores()
        .then(result => {
          return result.map(periodo => ({
            value: periodo.codprof,
            text: periodo.nome
          }));
        })
        .catch(err => {
          SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TodosProfessores.vue